import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {extractRouteLinks} from './RouteLinkExtractor';

@Component({
  selector: 'app-site-map',
  imports: [],
  templateUrl: './site-map.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './site-map.component.scss',
})
export class SiteMapComponent implements OnInit {
  output = '';
  router = inject(Router);

  ngOnInit(): void {
    const links = extractRouteLinks(this.router.config);
    this.output = links.join('\n');
  }
}
